
import http from '../common/http-auth'
import type {RemoveUnsubscribeListType} from '../components/types/types';


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any, @typescript-eslint/restrict-template-expressions
export const getAllUnsubscribeEmail = async (clientId?:number) => {
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/unsubscribeemaillist/all?clientId=${clientId}` : '/unsubscribeemaillist/all';
    const response = await http.get(url);
    return response;
};


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const removeEmailsFromUnsubscribeList = async (data: RemoveUnsubscribeListType) => {
    const response = http.post(`/unsubscribeemaillist/removeemailsfromunsubscribelist`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any, @typescript-eslint/restrict-template-expressions
export const getAllResubscribeEmail = async (clientId?:number) => {
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/unsubscribeemaillist/resubscribedemaillist?clientId=${clientId}` : '/unsubscribeemaillist/resubscribedemaillist';
    const response = await http.get(url);
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const importUnsubscribeList = async (data: FormData, queryParams: Record<string, unknown>) => {
    const response = await http.post(`/unsubscribeemaillist/uploadcsv`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params: queryParams, 
    });
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const exportUnsubscribeList = async (params: Record<string, unknown>) => {
    const response = await http.get(`/unsubscribeemaillist/downloadcsv`, {
        params,
        responseType: 'blob'
    });
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const downloadImportTemplate = async () => {
    const response = await http.get(`/unsubscribeemaillist/downloadtemplate`, {
        responseType: 'blob'
    });
    return response;
};
